"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExistingRecommendation = exports.initAndGetRecommendationData = exports.getProductData = exports.getPagePath = exports.getPageType = exports.getPageData = exports.getDeliveryCountry = exports.getCustomerData = exports.fetchOrderRecommendationData = exports.fetchRecommendationData = void 0;
const axios_1 = require("@ocm/axios");
const fetchRecommendationData = async (url, axiosConfig) => {
    const path = getUrlWithoutContext(url);
    const { data } = await (0, axios_1.$axios)({
        url: "/rest/data-layer",
        params: { path },
        ...axiosConfig,
    });
    setRecommendationData(data);
    updateDataLayerRecommendationForTheTool(data);
    return data;
};
exports.fetchRecommendationData = fetchRecommendationData;
const fetchOrderRecommendationData = async (cartCode) => {
    const { data, } = await (0, axios_1.$axios)({
        url: `/rest/data-layer/order/${cartCode}`,
    });
    const recommendationData = {
        Recommendation: {
            ...window.recommendationData.Recommendation,
            customerData: data.Recommendation.customerData,
            orderData: data.Recommendation.orderData,
        },
    };
    setRecommendationData(recommendationData);
    updateDataLayerRecommendationForTheTool(recommendationData);
    return recommendationData;
};
exports.fetchOrderRecommendationData = fetchOrderRecommendationData;
const getUrlWithoutContext = (url) => {
    let path;
    if (url.startsWith("https://") || url.startsWith("http://")) {
        path = new URL(url);
    }
    else {
        path = new URL(url, window.location.origin);
    }
    return path.pathname.replace(window.currentContextPath, "");
};
const setRecommendationData = (data) => {
    window.recommendationData = data; // used by epoq and more
};
const updateDataLayerRecommendationForTheTool = (data) => {
    window.dataLayer[0] = data;
};
const getCustomerData = () => window.recommendationData.Recommendation.customerData;
exports.getCustomerData = getCustomerData;
const getDeliveryCountry = () => { var _a; return ((_a = (0, exports.getCustomerData)().deliveryCountry) !== null && _a !== void 0 ? _a : "DE").toLowerCase(); };
exports.getDeliveryCountry = getDeliveryCountry;
const getPageData = () => window.recommendationData.Recommendation.pageData;
exports.getPageData = getPageData;
const getPageType = () => { var _a, _b; return (_b = (_a = (0, exports.getPageData)()) === null || _a === void 0 ? void 0 : _a.pageType) !== null && _b !== void 0 ? _b : ""; };
exports.getPageType = getPageType;
const getPagePath = () => { var _a, _b; return (_b = (_a = (0, exports.getPageData)()) === null || _a === void 0 ? void 0 : _a.pagePath) !== null && _b !== void 0 ? _b : ""; };
exports.getPagePath = getPagePath;
const getProductData = () => window.recommendationData.Recommendation.productData;
exports.getProductData = getProductData;
const initAndGetRecommendationData = async () => {
    var _a;
    try {
        await (0, exports.fetchRecommendationData)("/cart");
    }
    catch (error) {
        error.message && console.error(error.message);
    }
    return {
        Recommendation: (_a = window.dataLayer[0]) === null || _a === void 0 ? void 0 : _a.Recommendation,
    };
};
exports.initAndGetRecommendationData = initAndGetRecommendationData;
const getExistingRecommendation = () => {
    var _a;
    window.dataLayer = window.dataLayer || [];
    return (_a = window.dataLayer.find((entry) => entry === null || entry === void 0 ? void 0 : entry.Recommendation)) === null || _a === void 0 ? void 0 : _a.Recommendation;
};
exports.getExistingRecommendation = getExistingRecommendation;
